import React from 'react';
import { Fieldset, FormNumber } from '~/components/FormControl';
import { Form } from 'react-bootstrap';
import { formLabel } from '~/utils/helpers';

function RankCheck() {
    return (
        <Fieldset className={'px-2'}>
            <Fieldset.Legend>{formLabel('RankCheck')}</Fieldset.Legend>
            <Form.Row>
                <FormNumber
                    name="rankWonCondition"
                    sm={6}
                />
                <FormNumber
                    name="rankLostCondition"
                    sm={6}
                />
            </Form.Row>
        </Fieldset>
    );
}

export default RankCheck;
